/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { forwardRef } from "react";
import { Chip, FormControlLabel, Switch, SwitchProps, Tooltip } from "@mui/material";
import MDBox from "dashboard-template/components/MDBox";
import IconButton from "./IconButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";


type FormInputProps = SwitchProps & {
  label?: string;
  tooltip?: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  name: string;
  value: boolean;
  helper?: boolean;
};

const FormSwitch = forwardRef<HTMLInputElement, FormInputProps>(
  ({ label, name, value, setFieldValue, tooltip, helper, ...rest }, ref) => {
    return (
      <MDBox display="flex" alignItems="center">
        <FormControlLabel
          control={
            <Switch
              name={name}
              {...rest}
              inputRef={ref}
              checked={value}
              onChange={(_event, checked) => {
                setFieldValue(name, checked);
              }}
            />
          }
          label={label}
        />
        {helper && (<span className="switch-span">
          <Chip color="secondary" label={value ? "Yes" : "No"} size="small" />
        </span>)}
        {tooltip && (
          <Tooltip title={tooltip} arrow>
            <IconButton size="small" tabIndex={-1}>
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </MDBox>
    );
  }
);

export default FormSwitch;
